import { Autocomplete, Box, Button, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ScanAssignDTO from '@src/adapters/dto/scan/ScanAssignDTO';

interface Props {
  scans: ScanAssignDTO[];
  onSelectScan(scan: ScanAssignDTO | null): void;
  onHandleMarkAsExtra(marked: boolean): void;
}

function Header({ scans, onHandleMarkAsExtra, onSelectScan }: Props) {
  const [selectedItem, setSelectedItem] = useState<ScanAssignDTO | null>(null);

  const [extraFile, setExtraFile] = useState(false);

  useEffect(() => {
    if (scans.length > 0) {
      setSelectedItem(scans[0]);
    }
  }, [scans]);

  useEffect(() => {
    if (onSelectScan) {
      onSelectScan(selectedItem);
    }
  }, [onSelectScan, selectedItem]);

  const handleSelectionChange = (
    event: React.SyntheticEvent,
    value: ScanAssignDTO | null
  ) => {
    setSelectedItem(value);
  };

  const handleMarkAsExtraFile = () => {
    setExtraFile((prev) => {
      onHandleMarkAsExtra(!prev);
      return !prev;
    });
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: '#fff',
        padding: theme.spacing(2),
      })}>
      <Box sx={{ width: '50%' }}>
        <Autocomplete
          noOptionsText="No options available"
          selectOnFocus
          onChange={handleSelectionChange}
          value={selectedItem}
          options={
            scans
              ? [...scans].sort(
                  (a, b) =>
                    -b.originalFilename.localeCompare(a.originalFilename)
                )
              : []
          }
          getOptionLabel={(option) => {
            return option.originalFilename;
          }}
          renderInput={(params) => <TextField {...params} />}
          sx={{ width: '400px' }}
        />
      </Box>
      <Box
        sx={{
          width: '50%',
          display: 'flex',
          justifyContent: 'end',
        }}>
        <Button
          variant={extraFile ? 'contained' : 'outlined'}
          size="medium"
          color="info"
          startIcon={<AttachFileIcon />}
          sx={(theme) => ({ marginRight: theme.spacing(2) })}
          onClick={handleMarkAsExtraFile}>
          Mark as Extra File
        </Button>
      </Box>
    </Box>
  );
}

export default Header;
